import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { styled, css, useTheme } from 'styled-components';
import { getColor } from '../../V2/Elements/Icons/helpers.js';
const Svg = styled.svg `
  ${({ direction }) => direction === 'top' &&
    css `
      transform: rotate(-180deg);
    `}
  ${({ direction }) => direction === 'left' &&
    css `
      transform: rotate(90deg);
    `}
  ${({ direction }) => direction === 'right' &&
    css `
      transform: rotate(-90deg);
    `}
`;
const Icon = React.forwardRef(function Icon({ size = 24, alt, color, className, onClick, direction }, ref) {
    const theme = useTheme();
    const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
    return (_jsx(Svg, { ref: ref, onClick: onClick, width: size, direction: direction, height: size, viewBox: '0 0 415.35 523.34', fill: fillColor, className: className, children: _jsx("g", { children: _jsx("g", { children: _jsx("path", { d: 'M.92,20.17,182,513.51a15,15,0,0,0,27.9.66L414.17,29.94a15,15,0,0,0-3-16.18l-.61-.6a15,15,0,0,0-17-2.46L256.37,79.56A106.63,106.63,0,0,1,156.2,77.19L22.35,1.92A15,15,0,0,0,.92,20.17Z' }) }) }) }));
});
export default React.memo(Icon);
